import React, { useEffect, useRef, useState } from 'react';

import {
  KitDocumentModel,
  SubmissionKitDocumentModel,
} from './components/KitModels';
import { useMedia } from 'react-use';
import { showToast } from '../shared/Toast';
import submissionKitService from '../services/SubmissionKitService';
import mediaKitService from '../services/MediaKitService';
import {
  fromRole,
  getStorageNotification,
  KitDocumentType,
  saveStorageNotification,
  SbCurrentUser,
  SubmissionBoardModel,
  SubmissionKitTagsModel,
} from '../submission_boards/component/SbModel';
import {
  CropIcon,
  InfoIcon,
  RefreshCcwIcon,
  XIcon,
  PencilLine,
  EyeIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ExternalLinkIcon,
} from 'lucide-react';
import SkTagItem from './components/SkTagItem';
import MediaKitModal from '../submission_boards/component/MediaKitModal';
import CropImage from '../shared/CropImage';
import Button from '../submission_boards/component/Button';
import FilePreviewer from './components/FilePreviewer';
import Image from '../Image';
const defaultProjectPlaceHolder = require('../../assets/images/project_placeholder@2x.jpg');
import { humanize, getProfileHeightString, getProfileWeightString, isUndefinedNullEmpty } from '../submission_boards/component/SbModel';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { SUBMISSION_KIT_TAGS_HEADSHOT } from '../../constants/SubmissionKit';
import { SubscriptionTier } from '../user_plans/UserPlanModal';
import CustomTabs from '../submission_boards/component/CustomTabs';
import SbProfileDetail from '../submission_boards/recipient/SbProfileDetail';
import { useIsMobile } from '../submission_boards/component/useIsMobile';
export interface SubmissionKitsPageProps {
  currentUser: SbCurrentUser;
}
export default function SubmissionKitsPagev2({ currentUser }: SubmissionKitsPageProps) {
  // const [records, setRecords] = useState<SubmissionKitModel[]>([]);
  const [loginUser, setloginUser] = useState<SbCurrentUser | null>(null);
  // const [mediaKit, setMediaKit] = useState<MediaKitModel>();
  //syca_check2 const [mediaKitDocuments, setMediaKitDocuments] = useState<KitDocumentModel[]>([]);
  const [showGuideCard, setShowGuideCard] = useState(
    getStorageNotification('sk_talent') == 1 ? true : false
  );
  const [enableEdit, setEnableEdit] = useState(false);

  const [submissionKitDocumentsSelected, setSubmissionKitDocumentsSelected] = useState<
    SubmissionKitDocumentModel[]
  >([]);
  const [submissionKitTagsSelected, setSubmissionKitTagsSelected] = useState<
    SubmissionKitTagsModel[]
  >([]);
  const [submissionKitTagForAdd, setSubmissionKitTagForAdd] =
    useState<SubmissionKitTagsModel | null>(null);

  const [freeArchieveUser, setfreeArchieveUser] = useState<boolean>(
    loginUser && (loginUser.subscription_tier == SubscriptionTier.free ||
      loginUser.subscription_tier == SubscriptionTier.archive)
      ? true
      : false
  );
  const [dragOverId, setDragOverId] = useState<string | null>(null);
  const [showMediaKitModal, setshowMediaKitModal] = useState<boolean>(false);
  const [showCropModal, setshowCropModal] = useState<boolean>(false);
  const [submissionKitDocumentCropSelected, setSubmissionKitDocumentCropSelected] = useState<SubmissionKitDocumentModel | null>(null);
  const [mediaKit, setMediaKit] = useState<any>(null);
  const [mediaKitDocuments, setMediaKitDocuments] = useState<any[]>([]);
  const [userAvatarUrl, setUserAvatarUrl] = useState<string>('');
  const [userCroppedAvatarUrl, setUserCroppedAvatarUrl] = useState<string>('');
  const [userDataFromApi, setUserDataFromApi] = useState<any>(null);
  const [showPreviewModal, setShowPreviewModal] = useState<boolean>(false);
  const [previewMediaTag, setPreviewMediaTag] = useState<string>('');
  const scrollableDivRef = useRef(null);
  const [scrollable, setScrollable] = useState(false);
  const is_xs_res = useMedia('(min-width: 1px) and (max-width: 639px)', false);
  const [previewTabSelected, setPreviewTabSelected] = useState<number>(1);
  const [previewTabs, setPreviewTabs] = useState([
    { id: 3, name: 'Media', show: true },
    { id: 1, name: 'Info', show: true },
  ]);

  const [submissionKitTags, setSubmissionKitTags] = useState<SubmissionKitTagsModel[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const observerRef = useRef(null);
  const listRef = useRef(null);
  const [noMoreData, setNoMoreData] = useState<string>('');
  const perPage: number = 12; // Number of records to fetch per page

  const fromScreen: string = 'edit';
  // const [selectedSubmissionKit, setSelectedSubmissionKit] = useState<SubmissionKitModel | null>(
  //   null
  // );

  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);

    const [showProfileDetails, setShowProfileDetails] = useState(null);
    const [submissionBoardModelSelected, setsubmissionBoardModelSelected] = useState(null);
  
    const isMobile = useIsMobile();
  

  // Load first page
  useEffect(() => {
    console.log('sk::useEffect currentUser', currentUser);
    setfreeArchieveUser(
      currentUser.subscription_tier == SubscriptionTier.free || currentUser.subscription_tier == SubscriptionTier.archive
    );
    setloginUser(currentUser);
  }, [currentUser]);

  // Load first page
  useEffect(() => {
    console.log('sk::useEffect loginUser', loginUser);
       setIsLoading(true);
      fetchSubmissionKitDocuments();
   }, [loginUser]);

  useEffect(() => {
    console.log('submissionKitTags', submissionKitTags);
    if (fromScreen == 'view') {
      let filteredTag = submissionKitTags.filter(
        (item) => submissionKitDocumentsSelected.findIndex((item2) => item2.tag == item.name) >= 0
      );
      console.log('filteredTag', filteredTag);
      setSubmissionKitTagsSelected(filteredTag);
    } else {
      setSubmissionKitTagsSelected([...submissionKitTags]);
    }
     let submissionBoardModel:SubmissionBoardModel = {
          id: 0,
          title: '',
          multiple_hire: 0,
          sb_status: '',
          project_id: 0,
          created_by: 0,
          created_at: '',
          expire_at: '',
          total_profiles: 0,
          total_profiles_pending: 0,
          total_profiles_onboard: 0,
          total_profiles_rejected: 0,
          request:0
      };
      submissionBoardModel.submission_kit_tags = submissionKitTags;
      setsubmissionBoardModelSelected(submissionBoardModel)
      let profile =          {
            id: currentUser.id,
            // uuid: currentUser.uuid,
            firstName: currentUser.first_name,
            lastName: currentUser.last_name,
            imageUrl: userAvatarUrl,
            croppedAvatarUrl: userCroppedAvatarUrl,
            measureSystem: currentUser.measure_system,
            ethnicities: userDataFromApi?.ethnicities ?? '',
            height: userDataFromApi?.height ?? '',
            height_ft: userDataFromApi?.height_ft ?? '',
            height_in: userDataFromApi?.height_in ?? '',
            
            weight: userDataFromApi?.weight ?? '',
            weight_lbs: userDataFromApi?.weight_lbs ?? '',
            gender: userDataFromApi?.gender ?? '',
            email: currentUser.email,
            social_kits: userDataFromApi?.social_kits,
            cell_phone: userDataFromApi?.cell_phone ?? '',
            hair_make_up_kit:  
            {
              hair_color: userDataFromApi?.hair_make_up_kit?.hair_color,
              eye_color: userDataFromApi?.hair_make_up_kit?.eye_color
            },
            submission_kit:{
              submission_kit_documents: submissionKitDocumentsSelected
            },
            sb_profiles_media: null
        }
      setShowProfileDetails(profile);
  }, [submissionKitTags, submissionKitDocumentsSelected]);

  const fetchSubmissionKitDocuments = async () => {
    try {
      const resp = await submissionKitService.getSubmissionKitDocument();
      console.log('fetchSubmissionKitDocuments response:', resp);
      let user: any = { avatar_url: '', cropped_avatar_url: '' };

      if (resp && 'submission_kit_documents' in resp) {
        if (resp && 'user' in resp) {
          user = resp.user;
          setUserAvatarUrl(user.avatar_url || '');
          setUserCroppedAvatarUrl(user.cropped_avatar_url || '');
          setUserDataFromApi(user);  
        }
        let submission_kit_documents = resp.submission_kit_documents;
        
        const isFreeOrArchive = (loginUser || currentUser) && 
          ((loginUser?.subscription_tier || currentUser?.subscription_tier) === SubscriptionTier.free || 
           (loginUser?.subscription_tier || currentUser?.subscription_tier) === SubscriptionTier.archive);
        
        // For FREE users: ALWAYS use default headshot (replace any existing one)
        // For PRO users: Only add default if no headshot exists
        if (user.avatar_url || user.cropped_avatar_url) {
          // Use cropped avatar if available, otherwise fall back to full avatar
          const avatarUrl = user.cropped_avatar_url || user.avatar_url;
          const defaultHeadshot = {
            id: -1,
            submission_kit_id: -1,
            kit_document_id: -1,
            tag: SUBMISSION_KIT_TAGS_HEADSHOT,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            kit_document: {
              id: -1,
              featured: 0,
              created_at: new Date().toISOString(),
              uuid: '',
              record_id: -1,
              file_url: avatarUrl,
              file_name: 'headshot',
              file_content_type: 'image/jpeg',
              cropped_file_url: null,
              cropped_file_name: null,
              cropped_file_content_type: null,
              work_kit_id: null,
              wardrobe_kit_id: null,
              hair_make_up_kit_id: null,
            },
          };
          
          if (isFreeOrArchive) {
            submission_kit_documents = submission_kit_documents.filter(
              (item) => item.tag.toLowerCase() !== SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase()
            );
            submission_kit_documents.push(defaultHeadshot);
          } else {
            const hasHeadshot = submission_kit_documents.some(
              (item) => item.tag.toLowerCase() === SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase()
            );
            if (!hasHeadshot) {
              submission_kit_documents.push(defaultHeadshot);
            }
          }
        }
        console.log('Updated submission kit documents:', submission_kit_documents);
        setSubmissionKitDocumentsSelected(submission_kit_documents);
      }
      if (resp && 'submission_kit_tags' in resp) {
        setSubmissionKitTags(resp.submission_kit_tags);
      }
      
      // Fetch media kit information for cropping (only if not already loaded)
      if (!mediaKit?.uuid) {
        try {
          const mediaKitResp = await mediaKitService.fetchMediaKits('', 'new', 1, 999);
          if (mediaKitResp && mediaKitResp.media_kit) {
            setMediaKit(mediaKitResp.media_kit);
          }
          if (mediaKitResp && mediaKitResp.kit_documents) {
            setMediaKitDocuments(mediaKitResp.kit_documents);
          }
        } catch (error) {
          console.log('Error fetching media kit for cropping:', error);
        }
      }
    } catch (error) {
      console.error('Error while fetching submission kits:', error);
      showToast('Error while fetching submission kits.', 'danger');
      throw error; // Re-throw so refresh handler can catch it
    } finally {
      console.log('sk: fetchSubmissionKitDocuments Out');
      console.log('sk: isLoading false');
      setIsLoading(false);
    }
  };

  // Add a more targeted refresh function for after cropping
  const refreshAfterCrop = async () => {
    try {
      console.log('Refreshing submission kit after crop...');
      await fetchSubmissionKitDocuments();
      console.log('Successfully refreshed submission kit after crop');
    } catch (error) {
      console.error('Failed to refresh submission kit after crop:', error);
      throw error;
    }
  };

  //syca_check2
  // const fetchMediaKits = async (pageParam: number) => {
  //   try {
  //     if (noMoreData.length > 0 && pageParam != 0) {
  //       console.log('fetchSubmissionBoards no more data is set');
  //       return;
  //     }
  //     console.log('sk: fetchMediaKits In');
  //     if (mediaKitDocuments.length <= 0) {
  //       pageParam = 1;
  //     }
  //     let filter = '';
  //     const responseData = await mediaKitService.fetchMediaKits(filter, 'new', pageParam, 999999);
  //     if (responseData) {
  //       if (responseData.media_kit) {
  //         setMediaKit(responseData.media_kit);
  //       }
  //       if (responseData.kit_documents.length > 0) {
  //         if (responseData.kit_documents.length == perPage) {
  //           console.log('sk: fetchMediaKits page:', page);
  //           setPage((prev) => prev + 1);
  //           setNoMoreData('');
  //         } else {
  //           setNoMoreData('No more media...');
  //         }
  //         setMediaKitDocuments((prevRecords) => [...prevRecords, ...responseData.kit_documents]);
  //       } else {
  //         setNoMoreData('No more media...');
  //       }
  //       return;
  //     }
  //     if (mediaKitDocuments && mediaKitDocuments.length <= 0 && pageParam == 1) {
  //       setNoMoreData('No more media...');
  //     }
  //   } catch (error) {
  //     showToast('Error while fetching submission kits.', 'danger');
  //   } finally {
  //     console.log('sk: fetchMediaKits Out');
  //     console.log('sk: isLoading false');
  //     setIsLoading(false);
  //   }
  // };

  const isInSubmissionKit = (kitDocumentId: number): boolean => {
    return submissionKitDocumentsSelected.some(
      (submissionKitDoc) =>
        submissionKitDoc.kit_document_id === kitDocumentId && !submissionKitDoc.not_show
    );
  };

  const handleDragStart = (e: any, kit_document: any) => {
    // e.preventDefault();
    console.log('handleDragStart');
    // if (from === 'submission_kit') {
    console.log('handleDragStart submission_kit');
    const jsonItem = JSON.stringify(kit_document);
    e.dataTransfer.setData('application/json', jsonItem);
    // }
  };

  const handleDrop = async (event: any, tag: string) => {
    // event.preventDefault();
    setDragOverId(null);
    const jsonItem = event.dataTransfer.getData('application/json');
    try {
      // file_content_type "video/"
      const key_document = JSON.parse(jsonItem);
      const isVideoTag = submissionKitTagsSelected.filter((item: SubmissionKitTagsModel) => {
        return item.filetype == 2 && item.name == tag;
      });
      if (isVideoTag.length > 0) {
        if (key_document.file_content_type.indexOf('video/') < 0) {
          // show error message
          showToast('Only video media supported.', 'danger');
          return;
        }
      } else {
        if (key_document.file_content_type.indexOf('image/') < 0) {
          // show error message
          showToast('Only images are supported. Please select image.', 'danger');
          return;
        }
      }
      const itemsPresent = submissionKitDocumentsSelected.filter((submissionKitDocument, index) => {
        if (submissionKitDocument.tag !== tag) {
          return false;
        }
        if (submissionKitDocument.not_show) {
          return false;
        }
        return true;
      });
      if (itemsPresent && itemsPresent.length > 0) {
        showToast('Remove image/video first to add new one.', 'danger');
        return;
      }
      console.log('key_document', key_document);
      await addToSubmissionKit(key_document, tag);
    } catch (error) {
      if ('response' in error && 'data' in error.response && 'message' in error.response.data) {
        showToast(error.response.data.message, 'danger');
      } else {
        showToast('Failed to add media in submission kit, please try again.', 'danger');
      }

      console.error('Error parsing JSON data from drag event:', error);
    }
  };
  const handleDragOver = (event: React.DragEvent<HTMLDivElement>, targetId: string) => {
    console.log('handleDragOver');
    if (targetId != '') {
      setDragOverId(targetId);
    }
    event.preventDefault();
  };
  const selectedMediaKitAddHandler = async (key_document: KitDocumentModel) => {
    try {
      const isVideoTag = submissionKitTagsSelected.filter((item: SubmissionKitTagsModel) => {
        return item.filetype == 2 && item.name == submissionKitTagForAdd.name;
      });
      if (isVideoTag.length > 0) {
        if (key_document.file_content_type.indexOf('video/') < 0) {
          // show error message
          showToast('Only video media supported.', 'danger');
          return;
        }
      } else {
        if (key_document.file_content_type.indexOf('image/') < 0) {
          // show error message
          showToast('Only images are supported. Please select image.', 'danger');
          return;
        }
      }
      // const itemsPresent = submissionKitDocuments.filter((submissionKitDocument, index) => {
      //   if (submissionKitDocument.tag !== submissionKitTagForAdd.name) {
      //     return false;
      //   }
      //   if (submissionKitDocument.not_show) {
      //     return false;
      //   }
      //   return true;
      // });
      // if (itemsPresent && itemsPresent.length > 0) {
      //   showToast('Remove image/video first to add new one.', 'danger');
      //   return;
      // }
      console.log('key_document', key_document);
      return await addToSubmissionKit(key_document, submissionKitTagForAdd.name);
    } catch (error) {
      if ('response' in error && 'data' in error.response && 'message' in error.response.data) {
        showToast(error.response.data.message, 'danger');
      } else {
        showToast('Failed to add media in submission kit, please try again.', 'danger');
      }

      console.error('Error parsing JSON data from drag event:', error);
    }
    return false;
  };
  const addToSubmissionKit = async (kit_document: any, tag: string) => {
    console.log('addToSubmissionKit', kit_document);
    const resp = await submissionKitService.addInSubmissionKitDocument(kit_document.id, tag);
    if (resp && 'submission_kit_document' in resp) {
      let _submissionKitDocuments = [...submissionKitDocumentsSelected];
      
      // Remove default headshot (id: -1) when adding a custom headshot
      if (tag.toLowerCase() === SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase()) {
        _submissionKitDocuments = _submissionKitDocuments.filter(doc => 
          !(doc.tag.toLowerCase() === SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase() && doc.id === -1)
        );
      }
      
      const itemsPresent = _submissionKitDocuments.findIndex(
        (submissionKitDocument, index) => {
          if (submissionKitDocument.tag.toLowerCase() !== tag.toLowerCase()) {
            return false;
          }
          if (submissionKitDocument.not_show) {
            return false;
          }
          return true;
        }
      );
      if (itemsPresent >= 0) {
        _submissionKitDocuments[itemsPresent] = resp.submission_kit_document;
      } else {
        _submissionKitDocuments.push(resp.submission_kit_document);
      }
      setSubmissionKitDocumentsSelected(_submissionKitDocuments);
    }
    return true;
  };
  const removeFromSubmissionKit = async (
    submissionKitDocument: SubmissionKitDocumentModel
  ): Promise<boolean> => {
    console.log('removeFromSubmissionKit', submissionKitDocument);
    const resp = await submissionKitService.deleteFromSubmissionKitDocument(submissionKitDocument);
    if (resp) {
      let _submissionKitDocuments = [...submissionKitDocumentsSelected];
      let present: boolean = false;
      for (let indexRecs = 0; indexRecs < _submissionKitDocuments.length; indexRecs++) {
        const item = _submissionKitDocuments[indexRecs];
        if (item.id === submissionKitDocument.id) {
          _submissionKitDocuments.splice(indexRecs, 1);
          break;
        }
      }
      
      // If removing a headshot and user has avatar, add default headshot back
      if (submissionKitDocument.tag.toLowerCase() === SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase() && (userAvatarUrl || userCroppedAvatarUrl)) {
        // Use cropped avatar if available, otherwise fall back to full avatar
        const avatarUrl = userCroppedAvatarUrl || userAvatarUrl;
        const defaultHeadshot = {
          id: -1,
          submission_kit_id: -1,
          kit_document_id: -1,
          tag: SUBMISSION_KIT_TAGS_HEADSHOT,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          kit_document: {
            id: -1,
            featured: 0,
            created_at: new Date().toISOString(),
            uuid: '',
            record_id: -1,
            file_url: avatarUrl,
            file_name: 'headshot',
            file_content_type: 'image/jpeg',
            cropped_file_url: null,
            cropped_file_name: null,
            cropped_file_content_type: null,
            work_kit_id: null,
            wardrobe_kit_id: null,
            hair_make_up_kit_id: null,
          },
        };
        _submissionKitDocuments.push(defaultHeadshot);
      }
      
      setSubmissionKitDocumentsSelected(_submissionKitDocuments);
    }
    return resp;
  };
  const removeFromSubmissionKitClickHandler = async (tagName: any) => {
    try {
      const elements = submissionKitDocumentsSelected.filter((submissionKitDocument, index) => {
        return submissionKitDocument.tag === tagName;
      });
      if (elements.length <= 0) {
        showToast('No media present.', 'danger');
      }
      const resp = await removeFromSubmissionKit(elements[0]);
      if (resp) {
        showToast('Successfully removed media from Submission Kit', 'success');
      } else {
        showToast('Failed to remove media from Submission Kit', 'danger');
      }
    } catch (error) {
      console.error(error);
      if (
        error?.response?.data &&
        'errors' in error?.response?.data &&
        error?.response?.data?.message
      ) {
        showToast(error?.response?.data?.message, 'danger');
        return;
      }
    }
  };

  const cropImageClickHandler = async (submissionKitDocument: SubmissionKitDocumentModel) => {
    try {
      // Only allow cropping for images
      if (!submissionKitDocument.kit_document.file_content_type.startsWith('image')) {
        showToast('Cropping is only available for images.', 'danger');
        return;
      }
      
      // Check if we have media kit information for cropping
      if (!mediaKit?.uuid) {
        showToast('Media kit information not available. Please try again.', 'danger');
        return;
      }
      
      // Find the correct media kit document using kit_document_id
      const correctKitDocument = mediaKitDocuments.find(doc => doc.id === submissionKitDocument.kit_document_id);
      if (!correctKitDocument) {
        showToast('Original media kit document not found. Please try again.', 'danger');
        return;
      }
      
      // Create a new submission kit document with the correct kit document
      const correctedSubmissionKitDocument = {
        ...submissionKitDocument,
        kit_document: correctKitDocument
      };
      
      setSubmissionKitDocumentCropSelected(correctedSubmissionKitDocument);
      setshowCropModal(true);
    } catch (error) {
      showToast('Error opening crop dialog', 'danger');
    }
  };

  const removeCropSubmissionKitDocument = async (submissionKitDocument: SubmissionKitDocumentModel) => {
    try {
      if (!mediaKit?.uuid) {
        showToast('Media kit information not available. Please try again.', 'danger');
        return false;
      }

      const resp = await mediaKitService.deleteCropMediaKitDocument(
        mediaKit.uuid,
        submissionKitDocument.kit_document.id
      );
      
      if (resp) {
        // Update the submission kit documents to remove cropped file info
        let _submissionKitDocuments = [...submissionKitDocumentsSelected];
        for (let indexRecs = 0; indexRecs < _submissionKitDocuments.length; indexRecs++) {
          const item = _submissionKitDocuments[indexRecs];
          if (item.kit_document.id === submissionKitDocument.kit_document.id) {
            _submissionKitDocuments[indexRecs].kit_document.cropped_file_url = null;
            _submissionKitDocuments[indexRecs].kit_document.cropped_file_name = null;
            _submissionKitDocuments[indexRecs].kit_document.cropped_file_content_type = null;
            break;
          }
        }
        setSubmissionKitDocumentsSelected(_submissionKitDocuments);
        showToast('Successfully reset to original image', 'success');
        return true;
      }
    } catch (error) {
      showToast('Error removing crop', 'danger');
      console.error('Error removing crop:', error);
    }
    return false;
  };

  const removeCropSubmissionKitDocumentClickHandler = async (submissionKitDocument: SubmissionKitDocumentModel) => {
    try {
      await removeCropSubmissionKitDocument(submissionKitDocument);
    } catch (error) {
      showToast('Error removing crop', 'danger');
    }
  };
  const showPreview = () => {
    const firstTag = submissionKitTagsSelected.find(tag =>
      submissionKitDocumentsSelected.some(doc => doc.tag.toLowerCase() === tag.name.toLowerCase())
    );
    setPreviewMediaTag(firstTag ? firstTag.name.toLowerCase() : SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase());
    // Set initial tab based on screen size - Media for mobile, Info for desktop
    setPreviewTabSelected(window.innerWidth > 1 && window.innerWidth < 639 ? 3 : 1);
    setShowPreviewModal(true);
    setTimeout(() => checkHorizontalScroll(), 100);
  };

  const checkHorizontalScroll = () => {
    if (scrollableDivRef.current) {
      const { scrollWidth, clientWidth } = scrollableDivRef.current;
      setScrollable(scrollWidth > clientWidth);
    }
  };

  const getMediaFilesCount = () => {
    return submissionKitTagsSelected.filter(tag =>
      submissionKitDocumentsSelected.some(doc => doc.tag.toLowerCase() === tag.name.toLowerCase())
    ).length;
  };

  return (
    <div className="w-full flex flex-col flex-1 mx-auto">
      <div className="w-full px-0 py-0 mx-auto">
        <div className="w-full flex flex-col gap-5">
          {/* top filter bar */}
          <>
            <div className="w-full flex flex-row items-center justify-between gap-2 border-0 border-gray-300">
              <div className="w-full text-blue-403 flex flex-row items-center font-medium justify-center sm:justify-start relative gap-1-1" 
                style={{fontSize:'2rem'}}>
                Submission Kit
                {!showGuideCard && (
                  <InfoIcon
                    className="w-4-2 h-4-2 text-gray-700 cursor-pointer text-blue-600"
                    onClick={() => {
                      setShowGuideCard(true);
                      saveStorageNotification('sk_talent', 1);
                    }}
                  />
                )}
              </div>
            </div>
            {showGuideCard && (
              <div className="w-full p-5 bg-blue-100 text-blue-800 font-semibold rounded-lg relative gap-4 flex flex-col">
                {/* Close Button */}
                <div
                  className="absolute top-2 right-2 cursor-pointer w-5 h-5 flex items-center justify-center"
                  onClick={() => {
                    setShowGuideCard(false);
                    saveStorageNotification('sk_talent', 0);
                  }}
                >
                  <XIcon className="h-5 w-5" aria-hidden="true" />
                </div>
                {/* Main Title */}
                <div className="text-base font-semibold">Welcome to Submission Kit!</div>
                  <div className="flex flex-col space-y-2 pl-1 gap-4 text-base font-normal">
                    <div className="flex items-top gap-3 ">
                    <div className="h-5 w-5 flex items-center justify-center">
                      <div className="h-4 w-4 flex items-center justify-center">
                        <InfoIcon className="h-4 w-4 text-blue-400 stroke-2"></InfoIcon>
                      </div>
                    </div>
                      <div className="flex-1 leading-tight">
                        <span className="font-medium">
                          Think of a submission kit as a performer's "Digital Portfolio Folder"
                        </span>{' '}
                        that lives within their FILMIK profile. Just like your work, wardrobe, and hair
                        & makeup kits, you also now have a submission kit specifically designed for
                        casting opportunities.
                      </div>
                    </div>
                    <div className="flex items-top gap-3 ">
                      <div className="h-6 w-5 px-1 flex items-center justify-center">
                        <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                          &nbsp;
                        </div>
                      </div>

                      <div className="flex-1 leading-tight">
                        <span className="font-medium">Edit your default submission kit here:</span>{' '}
                        Add your photos and videos from your media kit here. All media added to your
                        kit will be automatically updated in real-time across every active
                        submission you are attached to.
                        <br />
                      </div>
                    </div>
                    <div className="flex items-top gap-3 ">
                      <div className="h-6 w-5 px-1 flex items-center justify-center">
                        <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                          &nbsp;
                        </div>
                      </div>

                      <div className="flex-1 leading-tight">
                        <span className="font-medium">
                          To update content for a specific submission only:
                        </span>{' '}
                        Go to your active submissions folder and update the media in that particular
                        submission for that project. Changes made to individual submissions will only
                        affect that specific project.
                        <br/>
                        To update content across all submissions: Make
                        changes here in your default submission kit, and they will instantly appear in
                        every submission you're attached to.
                      </div>
                    </div>
                    <div className="flex items-top gap-3">
                      <div className="h-6 w-5 px-1 flex items-center justify-center">
                        <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                          &nbsp;
                        </div>
                      </div>
                      <div className="flex-1 leading-tight">
                        As a <span className="font-medium">FILMIK Pro</span> user, you get additional
                        media slots for your submission kit and unlimited media in your media kit.
                      </div>
                    </div>
                </div>
              </div>
            )}
            <div className=" w-full flex flex-col justify-between gap-7 sm:px-7 py-7 border border-blue-403 rounded-2xl">
              <div className=" w-full flex flex-col gap-2-1">
                <div className=" flex flex-row items-center justify-center font-bold text-lg"
                >
                  Current Submission Kit
                </div>

                {/* Action Buttons */}
                {!isLoading && !enableEdit && (
                  <div className="flex flex-col sm:flex-row gap-2-1 items-center justify-center py-2">
                    <div style={isMobile ? { width: '18.4375rem', height: '2.625rem' } : {}}>
                      <Button
                        id={'sk_customize_btn_id'}
                        variant="secondary"
                        btn_size="small"
                        icon_position="hor"
                        className={`text-sm ${isMobile ? 'w-full h-full' : ''}`}
                        onClick={() => {
                          setEnableEdit(true);
                        }}
                      >
                        <div className="w-6 h-6 p-3px flex items-center justify-center">
                          <PencilLine className="w-4-2 h-4-2" aria-hidden="true" />
                        </div>
                        Customize Submission Kit
                      </Button>
                    </div>

                    <div style={isMobile ? { width: '18.4375rem', height: '2.625rem' } : {}}>
                      <Button
                        id={'sk_preview_btn_id'}
                        variant="primary"
                        btn_size="small"
                        icon_position="hor"
                        className={`text-sm ${isMobile ? 'w-full h-full' : ''}`}
                        onClick={() => {
                          showPreview();
                        }}
                      >
                        <div className="w-6 h-6 p-3px flex items-center justify-center">
                          <EyeIcon className="w-4-2 h-4-2" aria-hidden="true" />
                        </div>
                        Submission Preview
                      </Button>
                    </div>
                  </div>
                )}

                {/* Edit mode banner */}
                {enableEdit && (
                  <div className="flex flex-row items-center justify-center gap-5 py-2 px-4 rounded-lg">
                    <div className="text-base font-semibold">
                      Customize your Kit
                    </div>
                    <Button
                      id="cancel_edit_btn_id"
                      variant="secondary"
                      btn_size="small"
                      icon_position="hor"
                      onClick={() => {
                        setEnableEdit(false);
                      }}
                    >
                      <XIcon className="w-4 h-4" />
                      <span className="truncate">Close</span>
                    </Button>
                  </div>
                )}

                {/* SK all Tags start  */}
                <div className=" w-full flex flex-row py-4 px-2 sm:px-0 gap-2-1 flex-nowrap sm:flex-wrap items-start sm:justify-center overflow-x-auto scrollable-content ">
                  {isLoading ? (
                    // Skeleton loaders for images
                    Array.from({ length: 3 }).map((_, index) => (
                      <div key={`skeleton-img-${index}`} className="flex flex-col gap-2 animate-pulse  w-60"	>
                        <div className="bg-gray-300 rounded-lg h-60 w-60"></div>
                        <div className="h-4 bg-gray-300 rounded w-3/4 mx-auto"></div>
                      </div>
                    ))
                  ) : (
                    submissionKitTagsSelected
                      .filter((item) => item.filetype == KitDocumentType.Image)
                      .map((item, index) => {
                      const isProUser = currentUser.subscription_tier !== SubscriptionTier.free && 
                                       currentUser.subscription_tier !== SubscriptionTier.archive;
                      const isHeadshot = item.name.toLowerCase() === SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase();
                      
                      // Filter documents: For PRO users in edit mode, hide default headshot (id === -1)
                      const filteredDocuments = isProUser && enableEdit && isHeadshot
                        ? submissionKitDocumentsSelected.filter(doc => 
                            !(doc.tag.toLowerCase() === SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase() && doc.id === -1)
                          )
                        : submissionKitDocumentsSelected;
                      
                      return (
                        <SkTagItem
                          key={index}
                          upgradeUser={false}
                          allowFileNameEdit={(currentUser.subscription_tier == SubscriptionTier.free
                            && item.name.toLowerCase() == SUBMISSION_KIT_TAGS_HEADSHOT
                          )? false: true}
                          allowEdit={enableEdit}
                          hideEmptyTags={!enableEdit}
                          submissionKitTag={item}
                          dragOverId={dragOverId}
                          handleDragOver={async function (
                            event: React.DragEvent<HTMLDivElement>,
                            targetId: string
                          ): Promise<void> {
                            await handleDragOver(event, targetId);
                          }}
                          handleDrop={async function (event: any, tag: string): Promise<void> {
                            await handleDrop(event, tag);
                          }}
                          removeFromSubmissionKitClickHandler={async function (
                            tag: string
                          ): Promise<void> {
                            await removeFromSubmissionKitClickHandler(tag);
                          }}
                          cropImageClickHandler={async function (
                            submissionKitDocument: SubmissionKitDocumentModel
                          ): Promise<void> {
                            await cropImageClickHandler(submissionKitDocument);
                          }}
                          removeCropImageClickHandler={async function (
                            submissionKitDocument: SubmissionKitDocumentModel
                          ): Promise<void> {
                            await removeCropSubmissionKitDocumentClickHandler(submissionKitDocument);
                          }}
                          submissionKitDocuments={filteredDocuments}
                          showMediaKitForSk={async function (isReplace: boolean): Promise<void> {
                            console.log('showMediaKitForSk');
                            // await fetchMediaKits(page);
                            setshowMediaKitModal(true);
                            setSubmissionKitTagForAdd(item);
                            return;
                          }}
                          upgradeClickedHandler={async function (): Promise<void> {}}
                        />
                      );
                    })
                  )}
                  {!isLoading && freeArchieveUser && (
                    <>
                      <SkTagItem
                        upgradeUser={true}
                        allowFileNameEdit={ enableEdit?true:false}
                        allowEdit={false}
                        hideEmptyTags={false}
                        submissionKitTag={{ name: 'Photo 1', filetype: KitDocumentType.Image }}
                        dragOverId={null}
                        handleDragOver={async function (
                          event: React.DragEvent<HTMLDivElement>,
                          targetId: string
                        ): Promise<void> {}}
                        handleDrop={async function (event: any, tag: string): Promise<void> {}}
                        removeFromSubmissionKitClickHandler={async function (
                          tag: string
                        ): Promise<void> {}}
                        submissionKitDocuments={submissionKitDocumentsSelected}
                        showMediaKitForSk={async function (isReplace: boolean): Promise<void> {
                          return;
                        }}
                        upgradeClickedHandler={async function (): Promise<void> {
                          window.location.href = '/user_plans';
                        }}
                      />
                    </>
                  )}
                </div>
                <div className=" w-full flex flex-row py-4 px-2 sm:px-0 gap-2-1 flex-nowrap sm:flex-wrap items-start sm:justify-center overflow-x-auto scrollable-content ">
                  {isLoading ? (
                    // Skeleton loaders for videos
                    Array.from({ length: 2 }).map((_, index) => (
                      <div key={`skeleton-vid-${index}`} className="flex flex-col gap-2 animate-pulse" style={{ width: '15rem' }}>
                        <div className="bg-gray-300 rounded-lg" style={{ width: '15rem', height: '18.75rem' }}></div>
                        <div className="h-4 bg-gray-300 rounded w-3/4 mx-auto"></div>
                      </div>
                    ))
                  ) : (
                    submissionKitTagsSelected
                      .filter((item) => item.filetype == KitDocumentType.Video)
                      .map((item, index) => {
                        return (
                        <SkTagItem
                          key={index}
                          upgradeUser={false}
                          allowFileNameEdit={true}
                          allowEdit={enableEdit}
                          hideEmptyTags={!enableEdit}
                          submissionKitTag={item}
                          dragOverId={dragOverId}
                          handleDragOver={async function (
                            event: React.DragEvent<HTMLDivElement>,
                            targetId: string
                          ): Promise<void> {
                            await handleDragOver(event, targetId);
                          }}
                          handleDrop={async function (event: any, tag: string): Promise<void> {
                            await handleDrop(event, tag);
                          }}
                          removeFromSubmissionKitClickHandler={async function (
                            tag: string
                          ): Promise<void> {
                            await removeFromSubmissionKitClickHandler(tag);
                          }}
                          cropImageClickHandler={async function (
                            submissionKitDocument: SubmissionKitDocumentModel
                          ): Promise<void> {
                            await cropImageClickHandler(submissionKitDocument);
                          }}
                          removeCropImageClickHandler={async function (
                            submissionKitDocument: SubmissionKitDocumentModel
                          ): Promise<void> {
                            await removeCropSubmissionKitDocumentClickHandler(submissionKitDocument);
                          }}
                          submissionKitDocuments={submissionKitDocumentsSelected}
                          showMediaKitForSk={async function (isReplace: boolean): Promise<void> {
                            console.log('showMediaKitForSk');
                            // await fetchMediaKits(page);
                            setshowMediaKitModal(true);
                            setSubmissionKitTagForAdd(item);
                            return;
                          }}
                          upgradeClickedHandler={async function (): Promise<void> {}}
                        />
                      );
                    })
                  )}
                  {!isLoading && freeArchieveUser && (
                    <>
                      <SkTagItem
                        upgradeUser={true}
                        allowFileNameEdit={true}
                        allowEdit={false}
                        hideEmptyTags={false}
                        submissionKitTag={{ name: 'Reel 1', filetype: KitDocumentType.Video }}
                        dragOverId={null}
                        handleDragOver={async function (
                          event: React.DragEvent<HTMLDivElement>,
                          targetId: string
                        ): Promise<void> {}}
                        handleDrop={async function (event: any, tag: string): Promise<void> {}}
                        removeFromSubmissionKitClickHandler={async function (
                          tag: string
                        ): Promise<void> {}}
                        submissionKitDocuments={submissionKitDocumentsSelected}
                        showMediaKitForSk={async function (isReplace: boolean): Promise<void> {
                          return;
                        }}
                        upgradeClickedHandler={async function (): Promise<void> {
                          window.location.href = '/user_plans';
                        }}
                      />
                    </>
                  )}
                </div>
                {/* SK all Tags end */}
              </div>
            </div>
            {showMediaKitModal && (
              <MediaKitModal
                from={'sk'}
                currentUser={currentUser}
                mediaKitDocuments={[]}
                submissionKitDocuments={submissionKitDocumentsSelected}
                filetype={submissionKitTagForAdd ? submissionKitTagForAdd.filetype : 0}
                dialogCloseHandler={function (): void {
                  setSubmissionKitTagForAdd(null);
                  setshowMediaKitModal(false);
                }}
                selectedMediaKitHandler={async function (
                  kitDocumentModel: KitDocumentModel
                ): Promise<boolean> {
                  return await selectedMediaKitAddHandler(kitDocumentModel);
                }}
              />
            )}
            {/* mediakit start */}
            {false && (
              <>
                {/* <div className=" w-full flex flex-col justify-between gap-5 px-7 py-5 border border-gray-300 shadow-xl-0-6-14-8">
                <div className=" w-full flex flex-row justify-between px-0 py-1">
                  <div className=" flex flex-row font-semibold text-xl items-center">
                    {!showMediaKitModal ? 'View Media Kit' : 'Your Media Kit'}
                  </div>
                  <div className=" flex flex-row">
                    {!showMediaKitModal && (
                      <div
                        id={'create_sb_btn_id'}
                        className="inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500  cursor-pointer"
                        onClick={async () => {
                          await fetchMediaKits(page);
                          setshowMediaKitModal(true);
                          // addSubmissionBoardClicked();
                        }}
                      >
                        <ChevronDownIcon className="h-6 w-6" />
                      </div>
                    )}
                    {showMediaKitModal && (
                      <>
                        <div
                          className="inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm  cursor-pointer"
                          onClick={() => {
                            setshowMediaKitModal(false);
                          }}
                        >
                          <ChevronUpIcon className="h-6 w-6" />
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {showMediaKitModal && (
                  <div className="border rounded-lg border-gray-300 bg-gray-100 flex flex-col px-10 pt-10 pb-5 gap-2-1">
                    <div className=" w-full flex flex-col gap-3">
                      <div className=" flex flex-row font-normal text-base text-gray-700 justify-center items-center pb-2">
                        Drag and drop any of these files into your
                        <span className=" font-semibold">&nbsp;Submission Kit&nbsp;</span> slots.
                      </div>
                      <div className=" flex flex-row justify-start items-center gap-5 overflow-x-scroll scrollable-content pb-5 mb-3">
                        {mediaKitDocuments.map((kit_document, index) => {
                          if (!kit_document.file_content_type.startsWith('image')) {
                            return <></>;
                          }
                          const isAdded = isInSubmissionKit(kit_document.id);
                          return (
                            <div
                              key={index}
                              className={'flex flex-col bg-white rounded-lg items-center relative'}
                              draggable="true"
                              style={{
                                overflow: 'clip',
                                width: '15rem',
                                boxShadow:
                                  '0px 0px 4px -1px rgba(0, 0, 0, 0.25), 0px 2px 10px -2px rgba(0, 0, 0, 0.15)',
                              }}
                              onDragStart={(e) => handleDragStart(e, kit_document)}
                              onDragOver={(e) => handleDragOver(e, '')}
                            >
                              {isAdded && (
                                <div className="absolute top-0.5 right-0.5 z-10 flex items-center justify-center w-7 h-7 bg-green-500 shadow-md rounded-tl-sm rounded-tr-md rounded-br-sm rounded-bl-2xl p-1.5">
                                  <Check className="w-3 h-3 sm:w-4 sm:h-4 text-black" />
                                </div>
                              )}
                              <a target={'_blank'}>
                                <div
                                  className={`flex flex-1 flex-col w-60 ${
                                    isAdded ? 'blur-sm opacity-60' : ''
                                  }`}
                                >
                                  <FilePreviewer
                                    file_url={kit_document.file_url}
                                    file_name={kit_document.file_name}
                                    file_content_type={kit_document.file_content_type}
                                  />
                                </div>
                              </a>
                             
                            </div>
                          );
                        })}
                        {mediaKitDocuments.map((kit_document, index) => {
                          if (!kit_document.file_content_type.startsWith('video')) {
                            return <></>;
                          }
                          const isAdded = isInSubmissionKit(kit_document.id);
                          return (
                            <div
                              key={index}
                              className={
                                'flex flex-col rounded-lg items-center justify-center relative'
                              }
                              draggable="true"
                              style={{
                                overflow: 'clip',
                                width: '15rem',
                                // boxShadow:
                                //   '0px 0px 4px -1px rgba(0, 0, 0, 0.25), 0px 2px 10px -2px rgba(0, 0, 0, 0.15)',
                              }}
                              onDragStart={(e) => handleDragStart(e, kit_document)}
                              onDragOver={(e) => handleDragOver(e, '')}
                            >
                        
                              {isAdded && (
                                <div className="absolute top-0.5 right-0.5 z-10 flex items-center justify-center w-7 h-7 bg-green-500 shadow-md rounded-tl-sm rounded-tr-md rounded-br-sm rounded-bl-2xl p-1.5">
                                  <Check className="w-3 h-3 sm:w-4 sm:h-4 text-black" />
                                </div>
                              )}
                              <a target={'_blank'}>
                                <div
                                  className={`flex flex-1 flex-col w-60 ${
                                    isAdded ? 'blur-sm opacity-60' : ''
                                  }`}
                                >
                                  <FilePreviewer
                                    file_url={kit_document.file_url}
                                    file_name={kit_document.file_name}
                                    file_content_type={kit_document.file_content_type}
                                  />
                                </div>
                              </a>
                             
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
              </div> */}
              </>
            )}
            {/* mediakit end */}
          </>
          {/* top filter bar */}
        </div>
      </div>

      {showCropModal && (
        <Transition.Root show={showCropModal} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            onClose={() => {
              setshowCropModal(false);
              setSubmissionKitDocumentCropSelected(null);
            }}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-customGray" />
            </Transition.Child>

            <div className="fixed z-10 hidden-after-load inset-0 overflow-y-auto">
              <div className="flex items-end justify-center justify-items-center items-center min-h-full pt-4 px-4 pb-8 text-center sm:block sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel
                    className="inline-block align-bottom w-11/12 bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all my-48 sm:align-middle sm:max-w-sm sm:w-full sm:p-6"
                  >
                    {/* Header */}
                    <div className="flex items-center justify-between px-6 py-4  border-gray-200">
                      <h2 className="text-lg font-medium text-gray-900">Crop your Image</h2>
                      <button
                        type="button"
                        className="flex h-8 w-8 items-center justify-center rounded-md hover:bg-gray-100"
                        onClick={() => {
                          setshowCropModal(false);
                          setSubmissionKitDocumentCropSelected(null);
                        }}
                      >
                        <span className="sr-only">Close menu</span>
                        <XIcon className="h-6 w-6 text-gray-400" aria-hidden="true" />
                      </button>
                    </div>
                    <div className="mt-4 md:mt-8 mb-4  w-full">
                      {submissionKitDocumentCropSelected && (
                        <>
                          <CropImage
                            kitDocumentModel={submissionKitDocumentCropSelected.kit_document}
                            record_uuid={mediaKit?.uuid || submissionKitDocumentCropSelected.kit_document.uuid}
                            maxFileSizeMb={5}
                            dialogCloseHandler={function (): void {
                              setshowCropModal(false);
                              setSubmissionKitDocumentCropSelected(null);
                            }}
                            refreshMediaHandler={async function (): Promise<void> {
                              try {
                                console.log('Crop completed, refreshing submission kit data...');
                                // Wait for the submission kit data to be refreshed
                                await refreshAfterCrop();
                                console.log('Refresh completed, closing crop modal...');
                                // Only close modal after data is successfully refreshed
                                setshowCropModal(false);
                                setSubmissionKitDocumentCropSelected(null);
                                showToast('Image cropped successfully!', 'success');
                              } catch (error) {
                                console.error('Error refreshing submission kit after crop:', error);
                                // Close modal even if refresh fails
                                setshowCropModal(false);
                                setSubmissionKitDocumentCropSelected(null);
                                showToast('Cropped successfully, but display refresh failed. Please reload the page.', 'danger');
                              }
                            }}
                          />
                        </>
                      )}
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}

      {/* Preview Modal */}
      {showPreviewModal && showProfileDetails && submissionBoardModelSelected && (console.log('showProfileDetails',showProfileDetails), <SbProfileDetail
        currentUser={currentUser}
        // project={project}
        submissionBoardModel={submissionBoardModelSelected}
        profileUser={showProfileDetails}
        fromScreen={fromRole.SB_PERFORMER}
        dialogCloseHandler={() => {
          setShowPreviewModal(false);
          // setShowProfileDetails(null);
        } }
        refreshSubmissionBoard={() => {
          // if (refreshSubmissionBoard) {
          //   refreshSubmissionBoard();
          // }
        } }
        prevNextProfile={async (value: number) => {

          return false;
        } } project={undefined}                                  ></SbProfileDetail>)
      }

      {false && showPreviewModal && (
        <Transition.Root show={showPreviewModal} as={Fragment}>
          <Dialog as="div" className="relative z-50" onClose={() => setShowPreviewModal(false)}>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 backdrop-blur-lg" />
            </Transition.Child>
            <div className="mt-16 fixed inset-0 z-10 flex items-center justify-center p-5 sm:px-16 sm:py-12 bg-gray-500 bg-opacity-300 mt-16 backdrop-blur-sm">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel
                  className="relative flex h-full w-full flex-col gap-2-1 pt-5 pb-10 bg-white shadow-xl-0-19-40-8 rounded-md"
                  style={{ maxWidth: '71.25rem', maxHeight: '50rem' }}
                >
                  <div className="h-full sm:scrollable-content sm:overflow-y-auto justify-items-center">
                    <div className="flex w-full h-full flex-col">
                      <div className="flex flex-col h-full justify-items-center gap-2-1">
                        {/* Header */}
                        <div className="flex w-full px-6 flex-row justify-between text-lg font-medium text-gray-900">
                          <div>Submission Preview</div>
                          <button
                            onClick={() => setShowPreviewModal(false)}
                            className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-gray-100 text-gray-500"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-6 w-6">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </div>

                        {/* Tabs - Show on mobile only */}
                        <div className="flex sm:hidden w-full px-6 gap-4 justify-between items-center border-b border-gray-200">
                          <div className="text-sm font-medium primary-color w-full flex flex-row">
                            <CustomTabs
                              tabSelected={previewTabSelected}
                              tabs={previewTabs}
                              tabSelectHandler={function (id: number): void {
                                setPreviewTabSelected(id);
                              }}
                            />
                          </div>
                        </div>

                        {/* Content */}
                        <div className="flex w-full flex-row gap-10 scrollable-content overflow-y-auto px-6" style={{ flex: 1 }}>
                          {/* Left: Media Preview */}
                          <div className={`flex flex-1 flex-col bg-white ${previewTabSelected === 3 ? '' : 'hidden sm:flex'} sm:w-2/3`}>
                            {/* Media Preview */}
                            <div className="flex flex-1 flex-col justify-center items-center bg-dark-deep-gray rounded-lg overflow-hidden" style={{ position: 'relative', alignSelf: 'stretch', flexGrow: 1 }}>
                              {submissionKitDocumentsSelected
                                .filter((doc) => doc.tag.toLowerCase() === previewMediaTag)
                                .slice(0, 1)
                                .map((doc, index) => {
                                  const imageUrl = doc.kit_document.cropped_file_url || doc.kit_document.file_url;
                                  if (doc.kit_document.file_content_type?.indexOf('image/') === 0) {
                                    return (
                                      <div key={index} className="photo-item h-full w-full">
                                        <a href={doc.kit_document.file_url} target="_blank" rel="noopener noreferrer" className="block no-underline">
                                          <Image
                                            alt={`Submission document ${index}`}
                                            src={imageUrl === 'icons/default_avatar.svg' ? '' : imageUrl}
                                            fallbackSrc={defaultProjectPlaceHolder}
                                            className="w-full h-full object-contain"
                                            style={{ position: 'absolute', left: '0%', right: '0%', top: '0%', bottom: '0%' }}
                                          />
                                        </a>
                                      </div>
                                    );
                                  }
                                  return (
                                    <div key={index} className="flex w-full justify-center items-center">
                                      <FilePreviewer
                                        showControl={true}
                                        file_url={imageUrl === 'icons/default_avatar.svg' ? '' : imageUrl}
                                        default_file_url={defaultProjectPlaceHolder}
                                        file_name={doc.kit_document.file_name ?? ''}
                                        file_content_type={doc.kit_document.file_content_type}
                                      />
                                    </div>
                                  );
                                })}
                            </div>

                            {/* Media Files Count */}
                            <div className="pt-5 pb-3 flex items-center justify-center" style={{ flex: 'none', order: 1, alignSelf: 'stretch', flexGrow: 0 }}>
                              <div className="flex font-medium text-sm">Media Files ({getMediaFilesCount()}):</div>
                            </div>

                            {/* Thumbnail Navigation */}
                            <div className="flex flex-1 flex-col rounded-lg px-2" style={{ flex: 'none', order: 2, alignSelf: 'stretch', flexGrow: 0 }}>
                              <div className="gap-2 flex justify-center flex-wrap flex-row items-center">
                                <div className={'relative flex w-full ' + (scrollable ? 'justify-start' : 'justify-center')}>
                                  {scrollable && (
                                    <button
                                      type="button"
                                      className="z-20 bg-white p-2 rounded-full border-0 hover:bg-gray-50 transition-all"
                                      onClick={() => {
                                        const container = document.getElementById('previewThumbScroll');
                                        if (container) container.scrollBy({ left: -80, behavior: 'smooth' });
                                      }}
                                    >
                                      <ChevronLeftIcon className="h-4 w-4 text-gray-600" />
                                    </button>
                                  )}

                                  <div
                                    ref={scrollableDivRef}
                                    id="previewThumbScroll"
                                    className={'flex gap-2 overflow-hidden scroll-smooth ' + (scrollable ? 'justify-start' : 'justify-center')}
                                    style={{ scrollBehavior: 'smooth' }}
                                  >
                                    {submissionKitTagsSelected.map((tag, indexKit) => {
                                      const thumbDoc = submissionKitDocumentsSelected.find(
                                        (doc) => doc.tag.toLowerCase() === tag.name.toLowerCase()
                                      );
                                      if (!thumbDoc) return null;

                                      const imageUrl = thumbDoc.kit_document.cropped_file_url || thumbDoc.kit_document.file_url;

                                      return (
                                        <button
                                          key={indexKit}
                                          className={`flex-shrink-0 flex flex-col items-center justify-end text-xs rounded-lg bg-white hover:bg-gray-50 overflow-hidden transition-all duration-200 ${
                                            previewMediaTag.toLowerCase() === tag.name.toLowerCase() ? 'border-0' : 'border-0'
                                          }`}
                                          onClick={() => setPreviewMediaTag(tag.name.toLowerCase())}
                                        >
                                          <div
                                            className="flex flex-1 items-center justify-center overflow-hidden w-full relative rounded-lg"
                                            style={{ width: thumbDoc.kit_document.file_content_type?.startsWith('image/') ? '3.75rem' : '6.255rem' }}
                                          >
                                            <div className="w-full flex items-center justify-center bg-dark-deep-gray rounded-lg overflow-hidden">
                                              <FilePreviewer
                                                showControl={false}
                                                file_url={imageUrl === 'icons/default_avatar.svg' ? '' : imageUrl}
                                                default_file_url={defaultProjectPlaceHolder}
                                                file_name={thumbDoc.kit_document.file_name ?? ''}
                                                file_content_type={thumbDoc.kit_document.file_content_type}
                                              />
                                            </div>
                                          </div>
                                          <span className="px-1 py-1 font-medium text-center truncate w-full" style={{ fontSize: '0.5rem' }}>
                                            {humanize(tag.name)}
                                          </span>
                                        </button>
                                      );
                                    })}
                                  </div>

                                  {scrollable && (
                                    <button
                                      type="button"
                                      className="z-20 bg-white p-2 rounded-full border-0 hover:bg-gray-50 transition-all"
                                      onClick={() => {
                                        const container = document.getElementById('previewThumbScroll');
                                        if (container) container.scrollBy({ left: 80, behavior: 'smooth' });
                                      }}
                                    >
                                      <ChevronRightIcon className="h-4 w-4 text-gray-600" />
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Right: User Info */}
                          <div className={`flex w-full sm:w-1/3 flex-col bg-white rounded-lg gap-4 shadow-sm h-full sm:px-4 ${previewTabSelected === 1 ? '' : 'hidden sm:flex'}`}>
                            <div className="text-2xl font-semibold primary-color gap-4 flex justify-between items-center pb-2-1 pb-5 pt-2.5 pb-5">
                              {currentUser.first_name} {currentUser.last_name}
                            </div>

                            {/* Gender / Height / Weight / Ethnicity / Hair / Eyes */}
                            <div className="flex w-full">
                              <div className="grid grid-cols-2 gap-4 w-full">
                                <div className="flex flex-col">
                                  <span className="text-11 font-semibold text-gray-500">Gender</span>
                                  <span className="text-13 text-gray-900">{humanize((userDataFromApi || currentUser as any).gender || '')}</span>
                                </div>
                                <div className="flex flex-col">
                                  <span className="text-11 font-semibold text-gray-500">Height / Weight</span>
                                  <span className="text-13 text-gray-900">
                                    {getProfileHeightString(userDataFromApi || currentUser as any, currentUser)}
                                    {isUndefinedNullEmpty(getProfileHeightString(userDataFromApi || currentUser as any, currentUser)) 
                                    || isUndefinedNullEmpty(getProfileWeightString(userDataFromApi || currentUser as any, currentUser)) ? '' : ' / '}
                                    {getProfileWeightString(userDataFromApi || currentUser as any, currentUser)}
                                  </span>
                                </div>
                                <div className="flex flex-col">
                                  <span className="text-11 font-semibold text-gray-500">Ethnicity</span>
                                  <span className="text-13 text-gray-900">
                                    {(userDataFromApi || currentUser as any).ethnicities ? humanize((userDataFromApi || currentUser as any).ethnicities.join(', ')) : ''}
                                  </span>
                                </div>
                                <div className="flex flex-col">
                                  <span className="text-11 font-semibold text-gray-500">Hair / Eyes</span>
                                  <span className="text-13 text-gray-900">
                                    {humanize((userDataFromApi || currentUser as any)?.hair_make_up_kit?.hair_color)}
                                    {isUndefinedNullEmpty((userDataFromApi || currentUser as any)?.hair_make_up_kit?.eye_color) || isUndefinedNullEmpty((userDataFromApi || currentUser as any)?.hair_make_up_kit?.hair_color) ? '' : ' / '}
                                    {humanize((userDataFromApi || currentUser as any)?.hair_make_up_kit?.eye_color)}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <hr className="my-4 w-full" />
                            <div className="flex flex-col items-start">
                              <div className="flex items-center leading-6">
                                <span className="w-16 text-11 font-semibold text-gray-500">Email</span>
                                <a href={`mailto:${currentUser?.email}`}>
                                  <span className="text-13 text-gray-900">{currentUser?.email}</span>
                                </a>
                              </div>
                              <div className="flex items-center leading-6">
                                <span className="w-16 text-11 font-semibold text-gray-500">Phone</span>
                                <a href={`phone:${(currentUser as any)?.cell_phone}`}>
                                  <span className="text-13 text-gray-900">{(currentUser as any)?.cell_phone}</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
      )}
    </div>
  );
}

